export const FORM_IDENTIFIER = 'app/UserPage/FORM_IDENTIFIER';
export const DEMO_FORM_IDENTIFIER = 'app/UserPage/DEMO_FORM_IDENTIFIER';
export const NEW_COMPANY_FORM_IDENTIFIER = 'app/UserPage/NEW_COMPANY_FORM_IDENTIFIER';

export const INIT = 'app/UserPage/INIT';
export const INIT_SUCCESS = 'app/UserPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/UserPage/INIT_FAILED';

export const SAVE = 'app/UserPage/SAVE';
export const SAVE_SUCCESS = 'app/UserPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/UserPage/SAVE_FAILED';

export const CLONE = 'app/UserPage/CLONE';
export const CLONE_SUCCESS = 'app/UserPage/CLONE_SUCCESS';
export const CLONE_FAILED = 'app/UserPage/CLONE_FAILED';

export const CREATE_NEW_COMPANY = 'app/UserPage/CREATE_NEW_COMPANY';
export const CREATE_NEW_COMPANY_SUCCESS = 'app/UserPage/CREATE_NEW_COMPANY_SUCCESS';
export const CREATE_NEW_COMPANY_FAILED = 'app/UserPage/CREATE_NEW_COMPANY_FAILED';
